import { render, staticRenderFns } from "./WflowFlowList.vue?vue&type=template&id=56f673e0&scoped=true"
import script from "./WflowFlowList.vue?vue&type=script&lang=js"
export * from "./WflowFlowList.vue?vue&type=script&lang=js"
import style0 from "./WflowFlowList.vue?vue&type=style&index=0&id=56f673e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f673e0",
  null
  
)

export default component.exports